<div class="container" style="padding: 0px !important">

  <div id="programmes">

    <div class="form-inline" style="margin-bottom:40px;margin-top:20px;">
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1"><span class="fa fa-search"></span></span>
          </div>
          <input type="text" name="term" [(ngModel)]="searchTerm" (focus)="collapseListeProgrammes()" class="form-control" placeholder="Recherche" aria-label="Recherche" aria-describedby="basic-addon1" autocomplete="off" role="presentation">
          <div class="input-group-prepend">
            <button class="btn btn-outline-secondary" style="border-color: #E8E8E8;" type="button" (click)="clearSearchTerm()"><i class="fa fa-times"></i></button>
          </div>
        </div>
      </div>
      <input type="button" value="Ajouter un programme" (click)="openDetailsModal()" class="btn btn-info" style="margin-left: 20px;" />
    </div>

    <div class="row header">
      <div class="col-md-1">
      </div>
      <div class="col-md-8 text-programme" (click)="changeSortKey('nom')">
        PROGRAMME&nbsp;&nbsp;<span [hidden]="sortReverse || sortKey != 'nom'" class="fa fa-sort-asc fa-lg"></span>
        <span [hidden]="!sortReverse || sortKey != 'nom'" class="fa fa-sort-desc fa-lg"></span>
      </div>

      <div class="col-md-1 text-center" (click)="changeSortKey('code')">
        &nbsp;&nbsp;&nbsp;CODE&nbsp;<span [hidden]="sortReverse || sortKey != 'code'" class="fa fa-sort-asc fa-lg"></span>
        <span [hidden]="!sortReverse || sortKey != 'programmeId'" class="fa fa-sort-desc fa-lg"></span>
      </div>

      <div class="col-md-1 text-center" (click)="changeSortKey('diplome')">
        &nbsp;&nbsp;&nbsp;SANCTION&nbsp;<span [hidden]="sortReverse || sortKey != 'diplome'" class="fa fa-sort-asc fa-lg"></span>
        <span [hidden]="!sortReverse || sortKey != 'diplome'" class="fa fa-sort-desc fa-lg"></span>
      </div>

      <!--<div class="col-md-1 text-center" (click)="changeSortKey('isActif')">
        &nbsp;ACTIF?&nbsp;<span [hidden]="sortReverse || sortKey != 'isActif'" class="fa fa-sort-asc fa-lg"></span>
        <span [hidden]="!sortReverse || sortKey != 'isActif'" class="fa fa-sort-desc fa-lg"></span>
      </div>-->

      <div class="col-md-1">
      </div>

    </div>

    <div id="accordion" class="panel-group" role="tablist" aria-multiselectable="false">
      <div class="panel panel-default" *ngFor="let programme of (sortReverse ? (programmes | orderBy:sortKey | reverse | filter:searchTerm) : (programmes | orderBy:sortKey | filter:searchTerm))">

        <div class="panel-heading collapsed" [attr.data-collection-id]="programme.programmeId">
          <div class="row">
            <div class="col-md-1">
              <a class="collapsed panel-title expand-icon"
                 data-toggle="collapse"
                 data-parent="#accordion"
                 (click)="loadCompetences(programme)"
                 href="#collapseProgramme{{programme.programmeId}}"
                 aria-expanded="true"
                 aria-controls="collapseProgramme{{programme.programmeId}}-collapsed">
                 <i class="fa fa-chevron-down"></i>
              </a>
            </div>
            <div class="col-md-8 no-padding text-accordeon">{{ programme.nom }}</div>
            <div class="col-md-1 text-accordeon text-center">{{ programme.code }}</div>
            <div class="col-md-1 text-accordeon text-center">{{ programme.diplome }}</div>
            <!--<div class="col-md-1 text-accordeon text-center"><i class="fa fa-check-square-o" *ngIf="programme.isActif"></i><i class="fa fa-square-o" *ngIf="!programme.isActif"></i></div>-->
            <!-- <div hidden class="col-md-1">{{ programme.programmeId }}</div>-->
            <div class="col-md-1">
              <button class="btn btn-secondary btn-sm pull-right" (click)="openDetailsModal(programme)" tooltip="Modifier ce programme" containerClass="cemeq-tooltip" container="body">Modifier</button>
            </div>
          </div>
          </div>
          <div #programmeRow
               id="collapseProgramme{{programme.programmeId}}"
               class="card-body collapse"
               data-parent="#accordion">
            <app-competences [competences]="programme.competences"
                             [programme]="programme">
            </app-competences>
          </div>
        </div>
      </div>
    </div>
    <ngx-loading [show]="loading" [config]="{fullScreenBackdrop:true, animationType:'three-bounce', primaryColour:'#f86c39', secondaryColour:'#808080'}"></ngx-loading>

    <button (click)="backToTop()" tooltip="Retour au haut de la page" containerClass="cemeq-tooltip" container="body" placement="left" class="btn back-to-top btn-lg"><span class="fa fa-arrow-circle-up"></span></button>




  </div>
